import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import PreviewBusDetail from '@/components/my-booking/modals/PreviewBusDetail'
import { getBookingTransportationQueryOptions } from '@/queries/query'

export const Route = createFileRoute(
  '/my-booking/$id/amend/view/$transportationId/detail',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const transportationId = Route.useParams({
    select: (s) => s.transportationId,
  })
  const {
    data: {
      data: { booked_transportation },
    },
  } = useSuspenseQuery(getBookingTransportationQueryOptions(transportationId))

  return (
    <PreviewBusDetail
      isOpen
      bus={booked_transportation}
      onClose={() => router.history.back()}
    />
  )
}
